module.exports = __webpack_public_path__ + "static/media/small-check-ic.928e0728.svg";